export default __webpack_public_path__ + "static/media/dsv-amazon-logistics.e66004b7.svg";